import { useTranslation } from 'react-i18next'
import type { JSX } from 'react'

import styles from './FormatStatus.module.scss'
import { ORDER_STATUS_DATA } from './order-statuses.constant'

interface FormatStatusProps {
  status?: string
  className?: string | null
  style?: React.CSSProperties
}

const FormatStatus = ({
  status = '',
  className = null,
  style = {},
}: FormatStatusProps): JSX.Element => {
  const { t } = useTranslation()
  const lowerCasedStatus = status?.toLowerCase()

  return (
    <span
      className={`${styles.icon} status-icon--${
        ORDER_STATUS_DATA[lowerCasedStatus]?.className
      } ${className}`}
      style={style}
    >
      {lowerCasedStatus ? t(ORDER_STATUS_DATA[lowerCasedStatus]?.title) : ''}
    </span>
  )
}

export default FormatStatus
